import { ReactNode } from "react";
import classNames from "classnames";
import useTranslate from "hooks/useTranslate";
import "./styles.sass";

type StoryDescriptionBlockProps = {
  title: string;
  description: string;
  className?: string;
  classNameTitle?: string;
  classNameDescription?: string;
  children?: ReactNode;
};

const StoryDescriptionBlock = (props: StoryDescriptionBlockProps) => {
  const {
    title,
    description,
    className,
    classNameTitle,
    classNameDescription,
    children,
  } = props;
  const t = useTranslate();

  const classNameBlock = classNames("StoryDescriptionBlock", className);
  const classNameTit = classNames(
    "StoryDescriptionBlock__title",
    classNameTitle,
  );
  const classNameDes = classNames(
    "StoryDescriptionBlock__description",
    classNameDescription,
  );

  return (
    <div className={classNameBlock}>
      <span className={classNameTit}>{t(title)}</span>
      <p className={classNameDes}>{t(description)}</p>
      {children}
    </div>
  );
};

export default StoryDescriptionBlock;
